import React from "react";
import { Box, Typography } from "@mui/material";
import { mdiAlertCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";

interface ExceptionBannerProps {
  title: string;
  message: string;
  showIcon?: boolean;
  isVisible?: boolean;
}

const ExceptionBanner: React.FC<ExceptionBannerProps> = ({
  title,
  message,
  showIcon = true,
  isVisible = false
}) => {
  if (!isVisible) return null;

  return (
    <Box
      display="flex"
      alignItems="center"
      px={2}
      py={1}
      bgcolor="#EB1C24"
      color="#fff"
      width="100%"
      borderRadius={1} // or use '8px' directly
      sx={{ fontSize: "0.875rem" }}
    >
      {showIcon && (
        <Icon
          path={mdiAlertCircleOutline}
          size={0.9}
          color="white"
          style={{ marginRight: 4 }}
        />
      )}
       <Typography component="span" sx={{ fontSize: 12 }}>
        <Box component="span" fontWeight="bold" display="inline">
          {title}
        </Box>{" "}
        {message}
      </Typography>
    </Box>
  );
};

export default ExceptionBanner;
